export var MS_IN_ONE_MINUTE = 60 * 1000;
export var MS_IN_ONE_HOUR = 60 * MS_IN_ONE_MINUTE;
export var MS_IN_ONE_DAY = 24 * MS_IN_ONE_HOUR;
